import { api } from '@/lib/axios';
import { Accommodation } from '@/features/alojamientos/types/accomodation.types';

export interface SampleSearchParams {
  sampleDate?: string;
  sampleTypeId: number;
  sampleUserId: number;
}

export interface SampleUser {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  role: string;
  status: string;
  created_at: string;
  last_login_at: string;
  password_changed_at: string;
}

export interface SampleType {
  id: number;
  name: string;
}

export interface Sample {
  id: string;
  sampleDate: string;
  accommodationId: string;
  sampleTypeId: number;
  sampleUserId: number;
  paxLastNight: number;
  occupiedRooms: number;
  specialDate1: string;
  specialDate2: string;
  specialDate3: string;
  specialDate4: string;
  notes: string;
  sampleRecordStatusId: number;
  createdAt: string;
  createdByUserId: number;
  updatedAt: string;
  updatedByUserId: number;
  accommodation: Accommodation;
  sampleType: SampleType;
  sampleUser: SampleUser;
}

export const searchSamples = async (params: SampleSearchParams): Promise<Sample[]> => {
  try {
    const { data } = await api.post<Sample[]>('/api/samples/search', params);
    console.log('samples acommodations: ', data);
    return data;
  } catch (error) {
    console.error('Error al buscar muestras:', error);
    throw new Error('Error al buscar muestras');
  }
}; 